import { Organization } from '../../types';

const HEADWAY_ORGANIZATION_ID = '89a02df1-f024-42b6-a708-9968725c1d0d';

export const isHeadwayOrganization = (organizations: Array<Organization>) => {
    return organizations[0]?.id === HEADWAY_ORGANIZATION_ID;
};
